module.exports = __webpack_public_path__ + "static/assets/hugeicons-hold-phone.svg";